import {
    FC,
    useState,
} from "react";
import {IMotorcycle} from "../../../interfaces/Interfaces";
import {getMotorcycleImageUrl} from "../../../utils/getMotorcycleImageUrl";
import {TwoWheeler} from "@mui/icons-material";

interface IMotorcycleMedia {
    motorcycle: IMotorcycle;
}

export const MotorcycleMedia: FC<IMotorcycleMedia> = ({motorcycle}) => {
    // TODO use theme colors

    const [hasError, setHasError] = useState(false);
    const src = getMotorcycleImageUrl(motorcycle);
    return hasError ? (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 8,
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                width: "100%",
                height: "100%",
                backgroundColor: "#f0f0f0",
            }}
        >
            <TwoWheeler style={{fontSize: "4rem", color: "#ccc"}}/>
        </div>
    ) : (
        <img
            src={src}
            alt={`${motorcycle.makerName} ${motorcycle.modelName}`}
            style={{
                borderRadius: 8,
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                width: "100%",
                height: "100%",
                objectFit: "contain",
                backgroundColor: "#fff",
            }}
            onError={() => setHasError(true)}
        />
    );
};
